import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M12 11l8-5H4zM4 8v10h16V8l-8 5z",
  opacity: ".3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H4V8l8 5 8-5v10zm-8-7L4 6h16l-8 5z"
})), 'LocalPostOfficeTwoTone');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/LocalPostOfficeTwoTone.js
// module id = 4650
// module chunks = 2